function ScheduleTarget() {
    "use strict";

    this.Id = -1;
    this.Name = '';
    this.TypeId = -1;
    this.TypeName = '';
    this.UniqueId = '';
    this.AddressType = '';
}
if (typeof exports !== 'undefined') {
    module.exports = ScheduleTarget;
}